import FullCalendar from '@fullcalendar/react';
import React, { useEffect } from 'react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';

import {
  CALENDAR_TYPES,
  RESOURCE_TYPES,
} from '../../../../Utils/helper/schedulerExamHelper';
import {
  getFacilityBookedSlots,
  getFacultyBookingsData,
  getSessionData,
  getCampusHolidaysData,
} from '../../../../Utils/apiServices';

export default function ResourceCalendar(props) {
  const { id, name, resourceType, calendarType } = props;

  const [events, setEvents] = React.useState([]);

  //   retrive events/bookings
  useEffect(() => {
    const getEventList = async () => {
      let querry = ``;
      if (!Object.values(RESOURCE_TYPES).includes(resourceType)) {
        // TODO: dispaly error as resourcetype is not valid
        return;
      }
      let payload =
        resourceType === RESOURCE_TYPES.FACULTY
          ? { facultyId: id }
          : { facilityId: id };
      const sessionData =
        calendarType === CALENDAR_TYPES.SESSIONS
          ? await getSessionData(payload)
          : calendarType === CALENDAR_TYPES.ACADEMIC_PLANNER
          ? resourceType === RESOURCE_TYPES.FACULTY
            ? await getFacultyBookingsData({ facultyId: id })
            : resourceType === RESOURCE_TYPES.FACILITY
            ? await getFacilityBookedSlots({ facilityId: id })
            : null
          : null;
      const holidayData = await getCampusHolidaysData(querry);
      let holidayListData;
      let sessionListData;
      if (holidayData.length > 0) {
        holidayListData = holidayData?.map((e) => ({
          ...e,
          title: `${e?.holidayName} - ${e?.holidayType}`,
          start: e?.startDate,
          end: e?.endDate,
          editable: false,
          allDay: true,
          display: 'background',
          backgroundColor: 'rgb(127, 183, 126, 1)',
        }));
      }
      console.log('sessionData', sessionData);
      if (Object.values(sessionData).length > 0) {
        sessionListData = Object.values(sessionData).map((s) => ({
          ...s,
          title: s.activityType,
          start: `${s.startDate}`,
          end: `${s.endDate}`,
        }));
      }
      setEvents([...sessionListData, ...holidayListData]);
    };
    getEventList();
  }, [id, resourceType]);

  return (
    <div>
      <FullCalendar
        headerToolbar={{
          left: 'prev,date,next today',
          center: 'title',
          right: 'timeGridWeek,dayGridMonth',
        }}
        plugins={[dayGridPlugin, timeGridPlugin]}
        events={events}
      />
    </div>
  );
}
